import React from 'react';

import LinkedInShareSvg from 'assets/images/linkedin-share.svg';

import BaseIcon from './BaseIcon';

const LinkedInShareIcon = props => (
  <BaseIcon {...props} src={LinkedInShareSvg} />
);

export default LinkedInShareIcon;
